export default __webpack_public_path__ + "static/media/brigoIconMob.9d6e8ea4.svg";